import React from 'react'
import { Route, Routes, Navigate } from 'react-router-dom';
import LandingLayout from '../../_template/layout/LandingLayout';
import Landing from '../pages/landing/Landing';
import { 
    Platform, 
    FullyManaged, 
    Resource, 
    Contact,
    CustomBuilt,
    LanguageModels,
    BusinessSignUp,
    TermsAndConditions,
    AiMlServices
} from '../pages/landing/pages';
const LangingRoute = () => {
    return (
        <>
            <Routes>
                <Route path="/" element={<LandingLayout />}>
                    <Route index element={<Landing />} />
                    <Route path="/truvoice-platform" element={<Platform />} />
                    <Route path="/fully-managed" element={<FullyManaged />} />
                    <Route path="/custom-built" element={<CustomBuilt />} />
                    <Route path="/language-models" element={<LanguageModels />} />

                    <Route path="/ai-ml-services" element={<AiMlServices />} />
                    
                    <Route path="/resource" element={<Resource />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/sign-up" element={<BusinessSignUp />} />
                    <Route path="/terms-and-conditions" element={<TermsAndConditions />} />

                </Route>
                <Route path="*" element={<Navigate to="/error" />} />
            </Routes>
        </>
    )
}

export default LangingRoute